import DatePicker from "react-datepicker"

type ReturnDatePickerProps = {
    value: Date | null
    minDate: Date
    onChange: (date: Date | null) => void
}

export const ReturnDatePicker = ({ value, minDate, onChange }: ReturnDatePickerProps) => (
    <div className="flex items-center gap-1">
        <DatePicker
            placeholderText="Когда"
            selected={value}
            wrapperClassName="react-datepicker-avia react-datepicker-avia-return"
            dateFormat="dd.MM.yyyy"
            minDate={minDate}
            onChange={onChange}
            popperProps={{ placement: 'bottom' }}
        />
        {value && (
            <button
                type="button"
                className="shrink-0 w-5 h-5 flex items-center justify-center text-color-dark"
                aria-label="Очистить дату возвращения"
                onClick={() => onChange(null)}
            >
                ×
            </button>
        )}
    </div>
)
